import { useEffect, useState } from "react";

export function Preloader() {
  const [bitti, setBitti] = useState(sessionStorage.getItem("ozalp_load") === "1");
  const [dolu, setDolu] = useState(false);
  const [cikis, setCikis] = useState(false);
  useEffect(() => {
    if (bitti) return;
    const t0 = setTimeout(() => setDolu(true), 40);
    const t1 = setTimeout(() => setCikis(true), 850);
    const t2 = setTimeout(() => { sessionStorage.setItem("ozalp_load", "1"); setBitti(true); }, 1350);
    return () => { clearTimeout(t0); clearTimeout(t1); clearTimeout(t2); };
  }, [bitti]);
  if (bitti) return null;
  return (
    <div id="onyukleyici" style={{ opacity: cikis ? 0 : 1, transition: "opacity .5s ease" }} data-testid="preloader">
      <span>ÖZALP</span>
      <div id="cubuk"><i style={{ width: dolu ? "100%" : "0%", transition: "width .8s cubic-bezier(.4,0,.2,1)" }} /></div>
    </div>
  );
}
